import { cloneDeep, compact, defaultsDeep, map } from 'lodash';
import {
  DynamicTableColumnConfig,
  DynamicTableConfig,
  DynamicTableVariantsDef,
} from '../interfaces/dynamic-table.interface';

export function dynamicTableBuilder(configDef: DynamicTableVariantsDef) {
  return (config: Partial<DynamicTableConfig>) => {
    const columnsClone = cloneDeep(config.columns);
    const columns = compact(
      map(columnsClone, (column): DynamicTableColumnConfig | undefined => {
        const cols = defaultsDeep(
          cloneDeep(column),
          configDef.columns[column.id]
        );
        return cols;
      })
    );

    const sort = defaultsDeep(config.sort, configDef.sort);
    const pagination = defaultsDeep(config.pagination, configDef.pagination);

    return {
      columns,
      sort,
      pagination,
    };
  };
}
